import axios from 'axios';
import * as ls from '../helpers/localStorage';
import store from '../store';

export const API_VERSION = 'v1';
export const API_URL = `https://api.addsoft.nl/${API_VERSION}`;

axios.defaults.headers.common = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};

// interceptor here ensures that we check for the token in local storage every time an request is made
axios.interceptors.request.use((config) => {
    const token = ls.get('account:token');

    if (token !== null)
    {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
}, (error) => {
    console.error(error);
    return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
    if (response.data.token)
    {
        // update the token
        ls.set('account:token', response.data.token);
    }

    return response;
}, (error) => {
    console.error(error);

    if (error.response.status === 401)
    {
        store.dispatch('account/logout');
    }

    return Promise.reject(error);
});
